import { useLoginStatus } from "@website/hooks/auth-manager";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";

const products: Record<string, string> = {
  "/": "DH",
  "/رزرو-هتل": "DH",
  "/train": "Train",
  "/inter-flights": "IF",
  "/flights": "DF",
  "/bus": "Bus",
  "/bus-international": "IB",
  "/international-hotel": "IH",
  "/tour": "Tour",
  "/villa": "Villa"
};

export const useLogin = () => {
  const { isLoggedIn } = useLoginStatus();
  const router = useRouter();

  const [isProfileButtonExist, setIsProfileButtonExist] = useState(false);
  const product =
    products[
      decodeURIComponent(router?.basePath) ||
        decodeURIComponent(router?.pathname)
    ];

  useEffect(() => {
    setIsProfileButtonExist(Boolean(product));
  }, [router, product]);

  const onProfileClick = useCallback(() => {
    window?.webengage?.track("st-profile-icon-clicked", {
      product
    });
    const query = {
      ...router.query,
      source: "profile",
      ...(product ? { product } : {})
    };
    const queryString = new URLSearchParams(query).toString();

    window.location.href = `/profile${queryString ? `?${queryString}` : ""}`;
  }, [router, product]);

  return {
    showAuth: isProfileButtonExist && isLoggedIn,
    onProfileClick
  };
};
